export default "__VITE_ASSET__BqPDd7sA__"